import { render } from "./PermissionsEdit.vue?vue&type=template&id=127d7f0e"
import script from "./PermissionsEdit.vue?vue&type=script&lang=js"
export * from "./PermissionsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__